export const headerTabsHeight = 80;
export const profileModalMobileTabsHeight = 40; 
export const profileModalTabsHeight = 96;
export const maxUploadCoverImageSizeMB = 10;
